import bee from "./Bee"
export default {
    name: "Locations",
    /*
     var query = {
         name: "",
         short_name: "",
     }
 */
    /* eslint-disable no-unused-vars */
    post_city(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            city: {
                ...query,
                country_id: 1 //botswana country id
            }
        }
        //first make sure that there is no
        //city with the same name
        bee.que()
            .get({
                cities: {
                    _w: [
                        ["name", "e", to_post.city.name]
                    ]
                }
            }, "unique_query")
            .post(to_post, "new_city")
            .before("new_city", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.cities.length > 0) {
                    tasks[index].errors.push("City name " + to_post.city.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            [is_admin: true],
            [is_drop_down: false]
        }
    */
    /* eslint-disable no-unused-vars */
    get_cities(query, success, fail) {
        // console.log(query);
        var q = {
            cities: {
                _ob: ["name"]
            }
        };
        if (query.is_admin && query.is_admin == true) {
            q = {
                cities: {
                    country: {
                    },
                    district: {

                    },
                    _ob: ["name"]
                },
            };
        }
        if (query.is_drop_down && query.is_drop_down == true) {
            q = {
                cities: {
                    _a: "id name short_name",
                    _ob: ["name"]
                }
            }
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.cities);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            id:4,
            is_admin: true,
            is_edit: true
        }
    */
    /* eslint-disable no-unused-vars */
    get_city(query, success, fail) {
        // console.log(query);
        var q = {};
        if (query.is_admin && query.is_admin == true) {
            q = {
                city: {
                    country: {},
                    district: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                businesses: {
                    _w: [
                        ["city_id", "e", query.id]
                    ]
                },
            };
        }
        if (query.is_edit && query.is_edit == true) {
            q = {
                city: {
                    district: {},
                    country: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            };
        }
        bee.get(q).then(res => {
            if (success) {
                if (query.is_edit && query.is_edit == true) {
                    success(res.city);
                } else if (query.is_admin && query.is_admin == true) {
                    success(res);
                }
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
     var query = {
         name: "",
         short_name: "",
     }
 */
    /* eslint-disable no-unused-vars */
    update_city(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            city: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        }
        delete to_post.city.id;
        //first make sure that there is no
        //city with the same name
        bee.que()
            .get({
                cities: {
                    _w: [
                        [
                            ["name", "e", to_post.city.name],
                            "and",
                            ["id", "ne", query.id],
                        ]
                    ]
                }
            }, "unique_query")
            .update(to_post, "update_city")
            .before("update_city", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.cities.length > 0) {
                    tasks[index].errors.push("City name " + to_post.city.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            [is_admin: true],
            [is_drop_down: false],
            [is_drop_down_with_cities: false],
            [is_drop_down_with_cities_wards: false]
        }
    */
    /* eslint-disable no-unused-vars */
    get_districts(query, success, fail) {
        // console.log(query);
        var q = {
            districts: {
                _ob: ["name"]
            }
        };
        if (query.is_admin && query.is_admin == true) {
            q = {
                districts: {
                    _ob: ["name"],
                    country: {
                    }
                },
            };
        }
        if (query.is_drop_down && query.is_drop_down == true) {
            q = {
                districts: {
                    _a: "id name ",
                    _ob: ["name"]
                }
            }
        }
        if (query.is_drop_down_with_cities && query.is_drop_down_with_cities == true) {
            q = {
                districts: {
                    _a: "id name ",
                    cities: {
                        _a: "id district_id name",
                    },
                    _ob: ["name"]
                }
            }
        }
        if (query.is_drop_down_with_cities_wards && query.is_drop_down_with_cities_wards == true) {
            q = {
                districts: {
                    _a: "id name ",
                    cities: {
                        _a: "id district_id name",
                    },
                    wards: {
                        _a: "id district_id name",
                    },
                    _ob: ["name"]
                }
            }
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.districts);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
     var query = {
         name: "",
     }
 */
    /* eslint-disable no-unused-vars */
    post_district(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            district: {
                ...query,
                country_id: 1 //botswana country id
            },
            city: {
                _fk_district_id: "district",
                country_id: 1, //botswana country id
                name: "No City",
                short_name: ""
            }
        }
        //first make sure that there is no
        //district with the same name
        bee.que()
            .get({
                districts: {
                    _w: [
                        ["name", "e", to_post.district.name]
                    ]
                }
            }, "unique_query")
            .post(to_post, "new_district")
            .before("new_district", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.districts.length > 0) {
                    tasks[index].errors.push("District name " + to_post.district.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            id:4,
            [is_admin: true],
            [is_edit: true]
        }
    */
    /* eslint-disable no-unused-vars */
    get_district(query, success, fail) {
        // console.log(query);
        var q = {};
        if (query.is_admin && query.is_admin == true) {
            q = {
                district: {
                    country: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                businesses: {
                    _w: [
                        ["district_id", "e", query.id]
                    ]
                },
            };
        }
        if (query.is_edit && query.is_edit == true) {
            q = {
                district: {
                    country: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            };
        }
        bee.get(q).then(res => {
            if (success) {
                if (query.is_edit && query.is_edit == true) {
                    success(res.district);
                } else if (query.is_admin && query.is_admin == true) {
                    success(res);
                }
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            id: 0
            name: "",
        }
    */
    /* eslint-disable no-unused-vars */
    update_district(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            district: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        }
        delete to_post.district.id;
        //first make sure that there is no
        //city with the same name
        bee.que()
            .get({
                districts: {
                    _w: [
                        [
                            ["name", "e", to_post.district.name],
                            "and",
                            ["id", "ne", query.id],
                        ]
                    ]
                }
            }, "unique_query")
            .update(to_post, "update_district")
            .before("update_district", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.districts.length > 0) {
                    tasks[index].errors.push("District name " + to_post.district.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
     var query = {
         name: "",
         district_id: "",
         city_id: ""
     }
 */
    /* eslint-disable no-unused-vars */
    post_ward(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            ward: {
                ...query,
                country_id: 1 //botswana country id
            }
        }
        //first make sure that there is no
        //ward with the same name
        bee.que()
            .get({
                wards: {
                    _w: [
                        ["name", "e", to_post.ward.name]
                    ]
                }
            }, "unique_query")
            .post(to_post, "new_ward")
            .before("new_ward", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.wards.length > 0) {
                    tasks[index].errors.push("Ward name " + to_post.ward.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            [is_admin: true],
            [is_drop_down: false]
        }
    */
    /* eslint-disable no-unused-vars */
    get_wards(query, success, fail) {
        // console.log(query);
        var q = {
            wards: {
                _ob: ["name"]
            }
        };
        if (query.is_admin && query.is_admin == true) {
            q = {
                wards: {
                    country: {
                    },
                    district: {

                    },
                    city: {

                    },
                    _ob: ["name"]
                },
            };
        }
        if (query.is_drop_down && query.is_drop_down == true) {
            q = {
                wards: {
                    _a: "id name",
                    _ob: ["name"]
                }
            }
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.wards);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
        /*
        var query = {
            id:4,
            is_admin: true,
            is_edit: true
        }
    */
    /* eslint-disable no-unused-vars */
    get_ward(query, success, fail) {
        // console.log(query);
        var q = {};
        if (query.is_admin && query.is_admin == true) {
            q = {
                ward: {
                    country: {},
                    district: {},
                    city: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                businesses: {
                    _w: [
                        ["ward_id", "e", query.id]
                    ]
                },
            };
        }
        if (query.is_edit && query.is_edit == true) {
            q = {
                ward: {
                    district: {},
                    country: {},
                    city: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            };
        }
        bee.get(q).then(res => {
            if (success) {
                if (query.is_edit && query.is_edit == true) {
                    success(res.ward);
                } else if (query.is_admin && query.is_admin == true) {
                    success(res);
                }
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
        /*
     var query = {
         name: "",
         district_id: "",
         city_id: "",
     }
 */
    /* eslint-disable no-unused-vars */
    update_ward(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            ward: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        }
        delete to_post.ward.id;
        //first make sure that there is no
        //ward with the same name
        bee.que()
            .get({
                wards: {
                    _w: [
                        [
                            ["name", "e", to_post.ward.name],
                            "and",
                            ["id", "ne", query.id],
                        ]
                    ]
                }
            }, "unique_query")
            .update(to_post, "update_query")
            .before("update_query", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.wards.length > 0) {
                    tasks[index].errors.push("Ward name " + to_post.ward.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
    /*
        var query = {
            name: "",
            district_id: "",
            city_id: "",
            ward_id: ""
        }
    */
    /* eslint-disable no-unused-vars */
    post_street(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            street: {
                ...query,
                country_id: 1 //botswana country id
            }
        }
        //first make sure that there is no
        //street with the same name
        bee.que()
            .get({
                streets: {
                    _w: [
                        ["name", "e", to_post.street.name]
                    ]
                }
            }, "unique_query")
            .post(to_post, "new_street")
            .before("new_street", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.streets.length > 0) {
                    tasks[index].errors.push("Street name " + to_post.street.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
            /*
     var query = {
         name: "",
         district_id: "",
         city_id: "",
         street_id: "",
     }
 */
    /* eslint-disable no-unused-vars */
    update_street(query, success, fail) {
        query.name = query.name.trim();
        var to_post = {
            street: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        }
        delete to_post.street.id;
        //first make sure that there is no
        //street with the same name
        bee.que()
            .get({
                streets: {
                    _w: [
                        [
                            ["name", "e", to_post.street.name],
                            "and",
                            ["id", "ne", query.id],
                        ]
                    ]
                }
            }, "unique_query")
            .update(to_post, "update_query")
            .before("update_query", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.streets.length > 0) {
                    tasks[index].errors.push("Street name " + to_post.street.name + " already used");
                    return false;
                }
                return tasks[index].nectar;
            })
            .send().then(res => {
                success(res);
            }).catch(errors => {
                fail(errors);
            });
    },
        /*
        var query = {
            [is_admin: true],
            [is_drop_down: false]
        }
    */
    /* eslint-disable no-unused-vars */
    get_streets(query, success, fail) {
        // console.log(query);
        var q = {
            streets: {
                _ob: ["name"]
            }
        };
        if (query.is_admin && query.is_admin == true) {
            q = {
                streets: {
                    country: {
                    },
                    district: {

                    },
                    city: {

                    },
                    ward: {

                    },
                    _ob: ["name"]
                },
            };
        }
        if (query.is_drop_down && query.is_drop_down == true) {
            q = {
                streets: {
                    _a: "id name",
                    _ob: ["name"]
                }
            }
        }
        bee.get(q).then(res => {
            if (success) {
                success(res.streets);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
        /*
        var query = {
            id:4,
            is_admin: true,
            is_edit: true
        }
    */
    /* eslint-disable no-unused-vars */
    get_street(query, success, fail) {
        // console.log(query);
        var q = {};
        if (query.is_admin && query.is_admin == true) {
            q = {
                street: {
                    country: {},
                    district: {},
                    city: {},
                    ward: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                businesses: {
                    _w: [
                        ["street_id", "e", query.id]
                    ]
                },
            };
        }
        if (query.is_edit && query.is_edit == true) {
            q = {
                street: {
                    district: {},
                    country: {},
                    city: {},
                    ward: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            };
        }
        bee.get(q).then(res => {
            if (success) {
                if (query.is_edit && query.is_edit == true) {
                    success(res.street);
                } else if (query.is_admin && query.is_admin == true) {
                    success(res);
                }
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
}